import {
	ChangeDetectorRef,
	Component,
	EventEmitter,
	Input,
	OnChanges,
	Output,
	SimpleChanges,
} from '@angular/core';
import { ESidebarMode } from 'app/enums/sidebarmode.enum';
import {
	INTERACTION_TYPE,
	ITEM_TYPE,
	SCOPE_TYPE,
	SUBSCOPE_TYPE,
} from 'app/interfaces/actiontracker.interface';
import { IContact } from 'app/interfaces/contact.interface';
import { ICalendarEvent } from 'app/interfaces/event.interface';
import {
	AppointmentSidebarFrom,
	ISidebar,
} from 'app/interfaces/sidebar.interface';
import { ITask } from 'app/interfaces/task.interface';
import { ActionTrackerService } from 'app/services/actiontracker.service';
import { ContactsService } from 'app/services/contacts.service';
import { EventsService } from 'app/services/events.service';
import { ISession } from 'modules/video-conference/interfaces/session.interface';
import { SessionService } from 'modules/video-conference/services/session/session.service';
import { PromptuaryService } from 'shared/services/promptuary/promptuary.service';

@Component({
	selector: 'appointment-details-sidebar',
	templateUrl: './appointment-details-sidebar.component.html',
})
export class AppointmentDetailsSidebarComponent implements OnChanges {
	public event: ICalendarEvent;
	public contact: IContact;
	public isLoading = true;
	public isFirstSession = false;
	public sessionHasTask = false;
	public sessionTask: ITask;

	@Input()
	public activeSidebar: ISidebar;

	@Input()
	public isVisible: boolean;

	@Output()
	public refreshEvents: EventEmitter<any> = new EventEmitter<any>();

	@Output()
	public showEvents: EventEmitter<ISidebar> = new EventEmitter<ISidebar>();

	@Output()
	public rescheduleEvent: EventEmitter<ISidebar> = new EventEmitter<ISidebar>();

	@Output()
	public schedulNewSessionEvent: EventEmitter<ISidebar> = new EventEmitter<ISidebar>();

	constructor(
		public eventService: EventsService,
		public sessionService: SessionService,
		public contactService: ContactsService,
		public actionTrackerService: ActionTrackerService,
		public changeDetectorReference: ChangeDetectorRef,
		public promptuaryService: PromptuaryService
	) {}

	public ngOnChanges(changes: SimpleChanges): void {
		if (this.isVisible && this.changesHasActiveSidebarId(changes)) {
			this.isLoading = true;
			this.requestAppointmentData().then((eventData: ICalendarEvent) => {
				this.event = eventData;

				if (this.event.contactId) {
					this.contactService
						.getContact(this.event.contactId)
						.subscribe((contactData: IContact) => {
							this.contact = contactData;
						});
				}

				this.actionTrackerService.eventTracker(
					SCOPE_TYPE.Appointment,
					SUBSCOPE_TYPE.Details,
					ITEM_TYPE.Sidebar,
					INTERACTION_TYPE.Seen
				);

				this.promptuaryService
					.getProfessionalTask(this.event.id, this.event.profileId)
					.subscribe(
						(task: ITask) => {
							if (task.isRegistered === true) {
								this.sessionHasTask = true;
								this.sessionTask = task;
							} else {
								this.sessionHasTask = false;
							}
						},
						(err) => {
							console.error('error', err);
						}
					);

				this.sessionService.getData(this.event.id).subscribe((sessionData) => {
					this.isFirstSession = this.checkIsFirstSession(sessionData);
					this.isLoading = false;
					this.changeDetectorReference.detectChanges();
				});
			});
		}
	}

	public checkIsFirstSession(sessionData: ISession): boolean {
		return sessionData.numberOfSessions === 1;
	}

	public changesHasActiveSidebarId(changes: SimpleChanges): boolean {
		return !!changes.activeSidebar?.currentValue.id;
	}

	public requestAppointmentData(): Promise<ICalendarEvent> {
		return this.eventService.getEvent(this.activeSidebar.id, false);
	}

	public emitRescheduleEvent(): void {
		this.rescheduleEvent.emit({
			...this.activeSidebar,
			contactId: this.event.contactId,
			id: this.activeSidebar.id,
		});
	}

	public closeSidebar(): void {
		this.showEvents.emit({
			...this.activeSidebar,
			id: null,
			mode: ESidebarMode.Appointments,
		});
	}

	public emitScheduleNewSessionEvent(): void {
		this.schedulNewSessionEvent.emit({
			...this.activeSidebar,
			from: AppointmentSidebarFrom.SCHEDULE_MODAL,
			contactId: this.event.contactId,
			id: null,
		});
	}
}
